/**
 * markdown
 */
import { marked } from "marked";
import markedAlert from "marked-alert";
import DOMPurify from "dompurify";
// a target="_blank" rel="noopener noreferrer"
const renderer = {
    link(token) {
        const html = marked.Renderer.prototype.link.call(this, token);
        return html.replace("<a", "<a target='_blank' rel='noopener noreferrer' ");
    },
};
// marked の設定
marked.use({
    pedantic: false,
    breaks: true,
    gfm: true,
    tokenizer: {
        // setext見出し無効化: "テキスト\n---" が <h2> にならないようにする
        lheading() {
            return undefined;
        },
        // ~~~ を文字列として扱う（``` のみ有効）
        fences(src) {
            if (/^ {0,3}~{3,}/.test(src)) {
                return undefined;
            }
            return marked.Tokenizer.prototype.fences.call(this, src);
        },
    },
});
marked.use({ renderer: renderer });
marked.use(markedAlert());
export const mdParse = () => {
    const mdParses = document.querySelectorAll(".mdParse:not([data-md-parsed])");
    mdParses.forEach((elem) => {
        const raw = elem.textContent || '';
        elem.dataset.rawMemo = raw;
        elem.innerHTML = DOMPurify.sanitize(String(marked.parse(raw)), { ADD_ATTR: ['target'] });
        elem.setAttribute('data-md-parsed', '');
    });
};
// DOMの準備が完了していたら即実行、そうでなければ待つ
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mdParse);
}
else {
    mdParse();
}
